import axios from "axios";
import { GET_CURRENT_TRANSACTION } from "../../../../config/firebase-api-config";


export const fetchCurrentTransaction = async (transactionID) => {

  try {
    const response = await axios.get(`${GET_CURRENT_TRANSACTION}/${transactionID}`);
    
    if(response.status === 200)
    { return response.data }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching gst data:', error);
    throw error;
  }
};